'use es6';

import * as client from 'DesignData/api/HublDocs';
import { HUBL_DOCS_FETCH } from 'DesignData/actions/ActionTypes';
/*
 * GET    /cos-rendering/v1/hubldoc
 */

export function fetch() {
  const {
    request,
    receive,
    error
  } = fetch;
  return dispatch => {
    dispatch(request());
    client.fetch().then(docs => {
      dispatch(receive(docs));
    }).catch(err => {
      dispatch(error(err));
    });
  };
}

fetch.request = () => {
  return {
    type: HUBL_DOCS_FETCH
  };
};

fetch.receive = docs => {
  return {
    type: HUBL_DOCS_FETCH,
    docs
  };
};

fetch.error = error => {
  return {
    type: HUBL_DOCS_FETCH,
    error
  };
};